// A filed document is a record: read only for good. Shown next to its name.

import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function RecordBadge({ node, className }) {
  const { t } = useTranslation('records');
  if (!node?.filedAt && !node?.filed_at) return null;
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-full border border-border bg-muted/50 px-2 py-0.5 text-[11px] font-medium text-foreground', className)}
      title={t('badge.hint')}
      data-testid="record-badge"
    >
      <Lock className="h-3 w-3" /> {t('badge.label')}
    </span>
  );
}
